<div
  class="w-full h-full flex flex-col bg-white rounded border border-gris-3 relative"
>
  <!-- Header Section -->
  <div class="flex flex-col w-full p-3 border-b border-gris-3 gap-3">
    <!-- Title and Create Button -->
    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2"
    >
      <div class="flex items-center">
        <div class="w-8 h-8 bg-vert-1 flex items-center justify-center rounded">
          <app-svg
            svgPath="/assets/svg/lock.svg"
            width="20"
            height="20"
            class="text-white"
          />
        </div>
        <span class="pl-2 text-lg font-semibold">
          {{ 'navbar.user_change_password' | translate }}
        </span>
      </div>

      <app-button-cta
        (onClick)="goToDashboard()"
        label="users.to_dashboard"
        svgName="chevron_left"
        iconType="material"
        class="inline-flex w-full sm:w-auto"
      />
    </div>
  </div>

  <!-- Form Section -->
  <div class="flex-1 p-6 overflow-y-auto">
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="updatePassword()"
      class="space-y-6"
    >
      <!-- Ancien mot de passe -->
      <div class="space-y-2">
        <label
          for="oldPassword"
          class="block text-sm font-medium text-gray-700"
        >
          {{ 'users.old_password' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <div class="mb-5 relative">
          <input
            id="oldPassword"
            formControlName="oldPassword"
            [type]="showOldPassword() ? 'text' : 'password'"
            class="w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-vert-1 focus:border-transparent transition-colors"
            [class.border-red-500]="isFieldInvalid('oldPassword')"
            placeholder="{{ 'users.enter_old_password' | translate }}"
          />
          <button
            type="button"
            (click)="togglePasswordVisibility('old')"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none flex items-center"
            tabindex="-1"
          >
            <span class="cursor-pointer material-icons text-xl">
              {{ showOldPassword() ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>

        @if (isFieldInvalid('oldPassword')) {
          <div class="flex items-center gap-1 pt-1 text-red-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>

            <span class="text-xs font-semibold">
              {{ 'users.old_password_required' | translate }}
            </span>
          </div>
        }
      </div>

      <!-- Nouveau mot de passe -->
      <div class="space-y-2">
        <label
          for="newPassword"
          class="block text-sm font-medium text-gray-700"
        >
          {{ 'users.new_password' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <input
            id="newPassword"
            formControlName="newPassword"
            [type]="showNewPassword() ? 'text' : 'password'"
            class="w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-vert-1 focus:border-transparent transition-colors"
            [class.border-red-500]="isFieldInvalid('newPassword')"
            placeholder="{{ 'users.enter_new_password' | translate }}"
          />
          <button
            type="button"
            (click)="togglePasswordVisibility('new')"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none flex items-center"
            tabindex="-1"
          >
            <span class="cursor-pointer material-icons text-xl">
              {{ showNewPassword() ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>

        <!-- Messages d'erreur pour le nouveau mot de passe -->
        @if (isFieldInvalid('newPassword')) {
          <div class="space-y-1 mt-2">
            @if (passwordForm.get('newPassword')?.hasError('required')) {
              <!-- Message simple si champ vide -->
              <div class="flex items-center gap-1 pt-1 text-red-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                  />
                </svg>
                <span class="text-xs font-semibold">
                  {{ 'users.new_password_required' | translate }}
                </span>
              </div>
            } @else {
              @if (hasPasswordError('newPassword', 'minLength')) {
                <div class="flex items-center gap-1 pt-1 text-red-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                  <span class="text-xs font-semibold">
                    {{ 'users.password_min_length' | translate }}
                  </span>
                </div>
              }
              @if (hasPasswordError('newPassword', 'uppercase')) {
                <div class="flex items-center gap-1 pt-1 text-red-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                  <span class="text-xs font-semibold">
                    {{ 'users.password_uppercase' | translate }}
                  </span>
                </div>
              }
              @if (hasPasswordError('newPassword', 'lowercase')) {
                <div class="flex items-center gap-1 pt-1 text-red-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                  <span class="text-xs font-semibold">
                    {{ 'users.password_lowercase' | translate }}
                  </span>
                </div>
              }
              @if (hasPasswordError('newPassword', 'digit')) {
                <div class="flex items-center gap-1 pt-1 text-red-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                  <span class="text-xs font-semibold">
                    {{ 'users.password_digit' | translate }}
                  </span>
                </div>
              }
              @if (hasPasswordError('newPassword', 'specialChar')) {
                <div class="flex items-center gap-1 pt-1 text-red-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                  <span class="text-xs font-semibold">
                    {{ 'users.password_special_char' | translate }}
                  </span>
                </div>
              }
            }
          </div>
        }

        <!-- Indicateur de force du mot de passe (optionnel mais recommandé) -->
        @if (newPasswordControl.value) {
          <div class="mt-2">
            <div class="flex gap-1">
              @for (i of [1, 2, 3, 4, 5]; track i) {
                <div
                  class="h-1 flex-1 rounded-full transition-colors"
                  [class]="getPasswordStrengthClass(i)"
                ></div>
              }
            </div>
            <p class="text-xs text-gray-600 mt-1">
              {{ getPasswordStrengthText() | translate }}
            </p>
          </div>
        }
      </div>

      <!-- Confirmation du mot de passe -->
      <div class="space-y-2">
        <label
          for="confirmPassword"
          class="block text-sm font-medium text-gray-700"
        >
          {{ 'users.confirm_password' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <input
            id="confirmPassword"
            formControlName="confirmPassword"
            [type]="showConfirmPassword() ? 'text' : 'password'"
            class="w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-vert-1 focus:border-transparent transition-colors"
            [class.border-red-500]="
              isFieldInvalid('confirmPassword') ||
              passwordForm.errors?.['passwordMismatch']
            "
            placeholder="{{ 'users.confirm_new_password' | translate }}"
          />
          <button
            type="button"
            (click)="togglePasswordVisibility('confirm')"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none flex items-center"
            tabindex="-1"
          >
            <span class="cursor-pointer material-icons text-xl">
              {{ showConfirmPassword() ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>

        @if (isFieldInvalid('confirmPassword')) {
          <div class="flex items-center gap-1 pt-1 text-red-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
            <span class="text-xs font-semibold">
              {{ 'users.confirm_password_required' | translate }}
            </span>
          </div>
        }

        @if (
          passwordForm.errors?.['passwordMismatch'] &&
          confirmPasswordControl.touched
        ) {
          <div class="flex items-center gap-1 pt-1 text-red-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
            <span class="text-xs font-semibold">
              {{ 'users.passwords_not_match' | translate }}
            </span>
          </div>
        }
      </div>

      <!-- Erreur si ancien = nouveau -->
      @if (
        passwordForm.errors?.['samePassword'] && newPasswordControl.touched
      ) {
        <div class="flex items-center gap-1 pt-1 text-red-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
          <span class="text-xs font-semibold">
            {{ 'users.same_password_error' | translate }}
          </span>
        </div>
      }

      <!-- Bouton de validation -->
      <div class="flex justify-end pt-4">
        <div class="relative inline-flex w-full max-w-xs justify-center">
          <app-button-cta
            [iconRotating]="isRotating()"
            [active]="passwordForm.valid && !isSubmitting()"
            (mouseenter)="showTooltip.set(passwordForm.invalid)"
            (mouseleave)="showTooltip.set(false)"
            label="users.update_password_action"
            svgName="lock_reset"
            iconType="material"
            type="green"
            class="inline-flex w-full"
          />
          @if (showTooltip() && passwordForm.invalid) {
            <div
              class="absolute bottom-full left-0 w-full max-w-xs mb-2 px-3 py-2 bg-rose-1 font-semibold text-white text-sm rounded shadow-lg z-50 whitespace-normal break-words"
            >
              <p class="max-w-xs break-words">
                {{ 'errors.change_password_missing_fields' | translate }}
              </p>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</div>
